import { type ComponentType, lazy } from "react";
import type { ToolMeta } from "../shared/tools";
import { meta as pricelistMeta, WINDOW_PARAMS as pricelistWindows } from "./pricelist/meta";

/**
 * Browser-side tool registry. Components are lazy-loaded so tools don't bloat the first page.
 * `Windows`: the tool's record windows, drawn over any page (like ServiceM8's job card) while the
 * address has any of `windowParams`: the keys its windows use, each tool's own, since every
 * page's address carries them (so windows stay open as you move between pages). `Settings`: its tab in Settings (meta.settings).
 */
export const webTools: Record<string, { meta: ToolMeta; Component: ComponentType; Windows?: ComponentType; windowParams?: readonly string[]; Settings?: ComponentType }> = {
    pricelist: {
        meta: pricelistMeta,
        Component: lazy(() => import("./pricelist/web")),
        Settings: lazy(() => import("./pricelist/SettingsSection")),
        Windows: lazy(() => import("./pricelist/WindowHost")),
        windowParams: pricelistWindows,
    },
};

/** A tool on the way: listed (sidebar, Home) with a "Coming soon" tag, so people know what's next. Not usable yet: no page, no access. */
export interface ComingSoonTool {
    id: string;
    name: string;
    description: string;
    /** lucide-react icon name, as ToolMeta.icon. */
    icon: string;
}

export const comingSoonTools: readonly ComingSoonTool[] = [
    { id: "ordering", name: "Stock ordering", description: "Order stock from your suppliers: what's running low, and what jobs need.", icon: "ShoppingCart" },
    { id: "quoting", name: "Quoting", description: "Build quotes from your price list, ready to send from ServiceM8.", icon: "FileText" },
];
